import React, { useState } from 'react';
import { translate } from 'react-i18next';

import ReportsDepreciation from 'components/reports/depreciation';
import * as Common from 'common/components';
import ReportsDepreciationFiltersButton from './depreciation/ReportsDepreciationFiltersButton';

const DepreciationReportList = ({
  accounts,
  costCenters,
  employees,
  status,
  children,
  companyId,
  count,
  filters,
  handleExport,
  handleExportXLSX,
  handleExportPDF,
  handleFiltersChange,
  handleFiltersSubmit,
  handleLimitChange,
  handleOrderChange,
  handlePageChange,
  isLoading,
  pagination,
  permissions,
  subcompanyId,
  t,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  return (
    <Common.Wrapper fluid={true}>
      {/* <ReportsDepreciation.Header
        companyId={companyId}
        subcompanyId={subcompanyId}
        handleExport={handleExport}
        handleExportPDF={handleExportPDF}
      /> */}
      <div className="col-12">
        <Common.Portlet
          title={t('reports.title') + ' > ' + t('reports.depreciation.subtitle')}
          icon={'table'}
          button={
            <ReportsDepreciationFiltersButton
              setIsCollapsed={setIsCollapsed}
              isCollapsed={isCollapsed}
            />
          }
          buttonTwo={
            <div className="btn-group pull-right">
              <Common.Dropdown>
                <Common.DropdownElement onClick={handleExportXLSX}>
                  <i className="fa fa-file-excel-o mr-1" />
                  {'  '}
                  {t('actions.exportXLSX')}
                </Common.DropdownElement>
                <Common.DropdownElement onClick={handleExport}>
                  <i className="fa fa-table mr-1" />
                  {'  '}
                  {t('actions.exportCSV')}
                </Common.DropdownElement>
                <Common.DropdownElement onClick={handleExportPDF}>
                  <i className="fa fa-file mr-1" />
                  {'  '}
                  {t('actions.exportPDF')}
                </Common.DropdownElement>
              </Common.Dropdown>
            </div>
          }
        >
          {isCollapsed ? null : (
            <ReportsDepreciation.Filters
              accounts={accounts}
              employees={employees}
              costCenters={costCenters}
              status={status}
              handleSubmit={handleFiltersSubmit}
              handleValueChange={handleFiltersChange}
              values={filters}
            />
          )}

          <div className="mb-2" style={{ position: 'relative' }}>
            <ReportsDepreciation.Table
              company={{ id: companyId }}
              subcompany={{ id: subcompanyId }}
              permissions={permissions}
              count={count}
              orderBy={pagination.orderBy}
              order={pagination.order}
              handleOrderChange={handleOrderChange}
            >
              {children}
            </ReportsDepreciation.Table>
            <Common.LoaderOverlay show={isLoading} />
          </div>
          <Common.Pagination
            {...pagination}
            handleLimitChange={handleLimitChange}
            handlePageChange={handlePageChange}
          />
        </Common.Portlet>
      </div>
    </Common.Wrapper>
  );
};

export default translate()(DepreciationReportList);



// WEBPACK FOOTER //
// src/components/reports/ReportsDepreciationList.js